<template>
	<div id="PageFaq">
		<div class="wrapper-fluid bg-picture-darken small-nav">
			<!-- <div class="wrapper-fluid "> -->

			<Navigation />

			<div class="container content-faq">

				<div class="row">
					<div class="col-12">
						<div class="wrapper-headlines">
							<div class="row justify-content-center">
								<div class="col-md-12 col-lg-auto">
									<h1 class="d-inline-block">&nbsp;</h1>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-md-12 col-lg-4 wrapper-rounded-content" style="padding-left:0">
						<div class="bg-blue-multiply rounded-corners mr15"></div>

						<div class="row justify-content-center headinline no-gutters mr15" >
							<div class="col-md-12">
								<h1 class="d-inline-block">{{ page.questionHeadline }}</h1>

								<ul>
									<!-- {% for faq in page.header.faq %}
										{{ faq.question }}
										
									{% endfor %} -->

									<li class="navi-my-element"  :class="{ active: (index === activeQuestion)}" v-for="(item, index) in page.faq">
										<a href="#" @click="faqClick(index)">{{ item.question }}</a>
									</li>
								</ul>
							</div>
						</div>
					</div>

					<div class="col-md-12 col-lg-8 wrapper-rounded-content content-answers">
						<div class="bg-blue-multiply rounded-corners"></div>
						<div class="row justify-content-center headinline">
							<div class="col-md-12">
								<h1 class="d-inline-block">{{ page.answerHeadline }}</h1>
								<div v-html="Answer"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
import find from 'lodash/find';
import { mapGetters } from 'vuex'
export default {
	name: 'PageFaq',
	data() {
		return{
			page: {},
			activeQuestion: 0,
			Answer: ""
		}
	},
	methods: {
		faqClick(index){
			this.Answer = this.page.faq[index].answer;
			this.activeQuestion = index;
		},

	},
	mounted() {

	    	var self = this;
			this.$store.dispatch('orm/GET_FAQ')
			.then(result => {
				console.log('GET_FAQ', result)
				self.page = result
				self.Answer = result.faq[0].answer;
			}).catch(err => { this.$store.commit("core/ADD_ERROR", err); })
	    	console.log(self.page);

	  },
}
</script>





// WEBPACK FOOTER //
// src/components/Pages/PageFaq.vue